import React from 'react'
import styled from 'styled-components'
import withAuth from '../../lib/withAuth'

const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

class SecureContent extends React.Component {
  render() {
    return <ContentContainer>{this.props.children}</ContentContainer>
  }
}

export default withAuth(SecureContent)
